module.exports = __webpack_public_path__ + "static/media/26shipping.6ee248a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/26shipping.png
// module id = 121
// module chunks = 0